<div class="card-body">
    <div class="form-group">
        <label for="year" class="form-label">Año</label>
        <select class="form-select" name="year" id="year" (change)="updateChart()" [(ngModel)]="year">
            <option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
        </select>
    </div>
    <div id="accounting-chart-expenses"></div>
</div>